import React from "react";
import style from "./index.module.scss";

interface ExerciseTopicsButtonsProps {
    topicCount: string;
    totalScore: string;
}

export default function ExerciseTopicsButtons({
    topicCount,
    totalScore
}: ExerciseTopicsButtonsProps) {
    return (
        <div className={style.root}>
            <div className={style.count}>
                共 {topicCount} 题， {totalScore} 分
            </div>
        </div>
    );
}
